import { render, staticRenderFns } from "./sendManage.vue?vue&type=template&id=156caf1c&scoped=true&"
import script from "./sendManage.vue?vue&type=script&lang=js&"
export * from "./sendManage.vue?vue&type=script&lang=js&"
import style0 from "./sendManage.vue?vue&type=style&index=0&id=156caf1c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156caf1c",
  null
  
)

export default component.exports